import { API_Handler } from "./API_Handler";
import { encryptData } from "../Utilities/EncryptData";

export const Feedback_APIs =
{
    Submit_Feedback: async (Request, Token) => await API_Handler.post('/feedback', { token: encryptData(Request) }, { headers: { Authorization: `Bearer ${Token}` } }),
}